import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import {
  Avatar,
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Spin,
  Tooltip,
  message,
  DatePicker,
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue, getMediaProperty } from "../../../../utils";
import { sortDataByOrder } from "../../../../utils/helper";
import "../../../slider/imageSlider.scss";
import "./Events.scss";
import ReactPlayer from "react-player/youtube";
import userServiceApi from "../../../../api/userServiceApi";
import SynthesiaVideo from "./SynthesiaVideo";
import { toast } from "react-toastify";
import reArrangeOrder from "../../../common/DragAndDropList/rearrangeHelper";
import {
  DragAndDropList,
  GifCreator,
  GifResultPreview,
  createEmptyGifState,
  withGifDefaults,
} from "../../../common";
import { setUpdatedValues } from "../../../../store/actions";
import ReactFlagsSelect from "react-flags-select";


const { TextArea } = Input;
const EVENT_OVERVIEW_MAX = 200;

const VIMEO_URL_PATTERN = /^(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/(video\/)?\d+([/?#].*)?$/i;

const isValidVimeoUrl = (url) => VIMEO_URL_PATTERN.test(String(url || "").trim());

const EVENT_BLOCK_FIELDS = [
  "eventName",
  "eventLogo",
  "description",
  "startDate",
  "endDate",
  "country",
  "address",
  "webLink",
  "venueLink",
];

export default function Events({ dataLoader, form, tabHandleSaveClick }) {
  const { micrositeId } = useParams();
  const { state } = useLocation();
  const tabKey = state;
  const { tabData, updatedValues, dispatch } = useStore();
  const whichTab = TAB_KEYS.events || "events";
  const eventsTabData = tabData?.[whichTab];
  const updatedValuesKeyCount = Object.keys(updatedValues).length;
  const { deleteSingleItem, postLoader } = useTab();
  const { updateImage } = useConnectsuForm();
  const [loader, setLoader] = useState(true);
  const [formChanged, setFormChanged] = useState(false);

  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const tabConfigId = localStorage?.getItem("selectedTabId");

  const emptyRow = {
    id: undefined,
    eventName: "",
    eventLogo: {},
    logoBlob: undefined,
    description: "",
    moreInfo: "",
    media: {},
    mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
    startDate: undefined,
    endDate: undefined,
    country: undefined,
    webLink: "",
    address: "",
    venueLink: "",
  };

  const refreshUnsavedState = useCallback(() => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find((item) => {
      const hasData =
        item?.eventName?.trim() ||
        item?.description?.trim() ||
        item?.moreInfo?.trim() ||
        item?.address?.trim() ||
        item?.venueLink?.trim() ||
        item?.webLink?.trim() ||
        item?.country ||
        item?.startDate ||
        item?.endDate ||
        item?.mediaLink?.url?.trim() ||
        item?.mediaLink?.mediaType ||
        item?.media ||
        item?.mediaLink?.gifCreator?.images?.length ||
        item?.mediaLink?.gifCreator?.generatedFile ||
        item?.eventLogo?.url ||
        item?.logoBlob;
      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  }, [form, whichTab]);

  useEffect(() => {
    localStorage.setItem("tab", "EVENTS");
  }, []);

  useEffect(() => {
    setFormChanged(updatedValuesKeyCount > 0);
  }, [updatedValuesKeyCount]);

  const hasEventLogo = (index) => {
    const logoBlob = form.getFieldValue([whichTab, index, "logoBlob"]);
    const eventLogo = form.getFieldValue([whichTab, index, "eventLogo"]);
    return !!(logoBlob || eventLogo?.url || eventLogo?.mediaProperty?.id);
  };

  const getBeEventImageUrl = (dataItem) => {
    if (dataItem?.blob) {
      return null;
    }
    if (dataItem?.mediaLink?.mediaType === "IMAGE" && dataItem?.mediaLink?.url) {
      return dataItem.mediaLink.url;
    }
    if (dataItem?.mediaLink?.mediaType === "GIF" && dataItem?.mediaLink?.url) {
      return dataItem.mediaLink.url;
    }
    if (dataItem?.media?.mediaType === "IMAGE" && dataItem?.media?.url) {
      return dataItem.media.url;
    }
    return null;
  };

  const getBeEventLogoUrl = (dataItem) => {
    if (!dataItem?.id || dataItem?.blob || dataItem?.logoBlob) {
      return null;
    }
    return dataItem?.eventLogo?.url || null;
  };

  const renderPreviewImage = (src, typeClass, commonStyles) => (
    <div className={`iframe-comp ${typeClass}`} style={commonStyles}>
      <img
        src={src}
        alt=""
        className="c1 carousel-image"
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    </div>
  );

  const renderMedia = (dataItem, rowIndex) => {
    const commonStyles = {
      display: "flex",
      justifyContent: "center",
    };

    if (
      dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={dataItem.mediaLink.url}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      if (!isValidVimeoUrl(dataItem.mediaLink?.url)) {
        return null;
      }
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <iframe
            title="Embedded video"
            src={dataItem.mediaLink.url}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
            style={{ backgroundColor: "black" }}
          />
        </div>
      );
    } else if (dataItem?.mediaLink?.mediaType === "IMAGE" && dataItem?.blob) {
      return renderPreviewImage(
        URL.createObjectURL(dataItem.blob),
        dataItem.mediaLink.mediaType,
        commonStyles
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "IMAGE" &&
      dataItem.mediaLink.url
    ) {
      return renderPreviewImage(
        dataItem.mediaLink.url,
        dataItem.mediaLink.mediaType,
        commonStyles
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "GIF"
    ) {
      const gifState = dataItem.mediaLink.gifCreator || {};
      const gifUrl = gifState.previewUrl || dataItem.mediaLink?.url;
      return (
        <GifResultPreview
          url={gifUrl}
          fileName={gifState.fileName}
          loading={!!gifState.generating}
          showEdit={!!gifUrl && gifState.isEditing === false}
          onEdit={() => {
            const current = form.getFieldValue([
              whichTab,
              rowIndex,
              "mediaLink",
              "gifCreator",
            ]);
            form.setFieldValue(
              [whichTab, rowIndex, "mediaLink", "gifCreator"],
              { ...createEmptyGifState(), ...current, isEditing: true }
            );
          }}
        />
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />
        </div>
      );
    }

    const eventImageFromBE = getBeEventImageUrl(dataItem);
    if (eventImageFromBE) {
      return renderPreviewImage(eventImageFromBE, "IMAGE", commonStyles);
    }

    const eventLogoFromBE = getBeEventLogoUrl(dataItem);
    if (eventLogoFromBE) {
      return renderPreviewImage(eventLogoFromBE, "EVENT_LOGO", commonStyles);
    }

    return null;
  };

  const findValue = (i, key) => {
    switch (key) {
      case "logoBlob":
        return form.getFieldValue([whichTab, i, "logoBlob"]);
      case "eventLogo":
        return form.getFieldValue([whichTab, i, "eventLogo"]);
      default:
        return getFormFieldValue(form, whichTab, i, key);
    }
  };

  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
    if (e === "GIF") {
      form.setFieldValue(
        [whichTab, i, "mediaLink", "gifCreator"],
        createEmptyGifState()
      );
    } else {
      form.setFieldValue([whichTab, i, "mediaLink", "gifCreator"], undefined);
    }
  };

  useEffect(() => {
    form.resetFields();
    if (eventsTabData && eventsTabData.length > 0) {
      form.setFieldsValue({
        [whichTab]: withGifDefaults(sortDataByOrder(eventsTabData)),
      });
    }
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  }, [eventsTabData, form, refreshUnsavedState, whichTab]);

  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save or clear the current item before adding a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];
    const newList = [emptyRow, ...currentList];
    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];

    const firstUnsavedIndex = currentList.findIndex((item) => !item?.id);

    if (firstUnsavedIndex === -1) {
      message.warning("No unsaved item to clear.");
      return;
    }

    const updatedList = currentList.map((item, idx) =>
      idx === firstUnsavedIndex
        ? {
          ...item,
          eventName: "",
          eventLogo: {},
          logoBlob: undefined,
          description: "",
          moreInfo: "",
          media: {},
          mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
          startDate: undefined,
          endDate: undefined,
          country: undefined,
          webLink: "",
          address: "",
          venueLink: "",
        }
        : item
    );

    form.setFieldsValue({ [whichTab]: updatedList });
  };

  const getEventBlockFieldNames = (index) =>
    EVENT_BLOCK_FIELDS.map((field) => [whichTab, index, field]);

  const handleSaveEvent = async (index) => {
    try {
      await form.validateFields(getEventBlockFieldNames(index));
      if (tabHandleSaveClick) {
        tabHandleSaveClick(form, index);
      } else {
        form.submit();
      }
      setCanAddNew(true);
      setHasUnsavedItem(false);
    } catch (error) {
      // Validation errors for this Event block are shown on its fields.
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (eventsTabData?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [eventsTabData]);

  useEffect(() => {
    refreshUnsavedState();
  }, [refreshUnsavedState]);

  useEffect(() => {
    const unsubscribe = form.subscribe?.(() => refreshUnsavedState());
    return () => unsubscribe?.();
  }, [form, refreshUnsavedState]);

  const updateEventLogo = (event, i) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const file = event.target?.files?.[0];
    if (!file) return;

    if (!allowedTypes.includes(file.type)) {
      toast.error("Only image files are allowed (JPG, PNG, JPEG)");
      return;
    }
    if (file.size > 2.5 * 1024 * 1024) {
      toast.error("File should not exceed 2.5MB");
      return;
    }

    const fields = form.getFieldValue(whichTab);
    if (fields && fields.length > 0) {
      const media = getMediaProperty(event);
      const modifiedData = fields.map((d, idx) => {
        if (idx === i) {
          d.eventLogo = { ...d.eventLogo, ...media.mediaProperty };
          d.logoBlob = media.blob;
        }
        return d;
      });

      form.resetFields();
      form.setFieldsValue({ [whichTab]: modifiedData });

      const prev = updatedValues;
      const prevItems = prev[whichTab];
      if (prevItems) {
        const names = [...prevItems, i];
        prev[whichTab] = names.filter((item, idx, arr) => arr.indexOf(item) === idx);
      } else {
        prev[whichTab] = [i];
      }
      dispatch(setUpdatedValues(prev));
      setTimeout(() => {
        form.validateFields([[whichTab, i, "eventLogo"]]).catch(() => { });
        setRefreshKey((prevKey) => prevKey + 1);
      }, 200);
    }
  };

  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  }

  return (
    <div className="newContantStyle eventsTab">
      <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        {tabKey === whichTab ? (
          <>
            <Col className="gutter-row tabContent" span={24}>
              <Form.List
                name={whichTab}
                initialValue={
                  tabData && tabData[whichTab] && tabData[whichTab].length > 0
                    ? withGifDefaults(sortDataByOrder(tabData[whichTab]))
                    : [emptyRow]
                }
              >
                {(fields, { add, remove, move }) => {
                  return (
                    <>
                      <Col
                        className="gutter-row tabContent"
                        xs={24}
                        sm={24}
                        md={14}
                        lg={14}
                        style={{ paddingRight: "25px" }}
                      >
                        <div className="inputBody">
                          <label></label>
                          <div className="button-container">
                            {hasUnsavedItem && (
                              <Button className="cancelBtn" type="button" onClick={handleClear}>
                                Clear
                              </Button>
                            )}
                            <Button className="greenBtn" onClick={handleAddMore}>
                              Add <PlusOutlined />
                            </Button>
                          </div>
                        </div>
                      </Col>

                      <Col className="gutter-row tabContent" xs={24} sm={24} md={10} lg={10} />

                      <DragAndDropList
                        fields={fields}
                        move={move}
                        form={form}
                        fieldName={whichTab}
                        onReorder={(payload) =>
                          reArrangeOrder(
                            userServiceApi.reArrangeCardsData({ micrositeId, tabConfigId }),
                            payload
                          )
                        }
                        renderItem={({ key, name, ...restField }, i) => (
                          <div className="card-item" key={key}>
                            <Col
                              className="gutter-row tabContent"
                              xs={24}
                              sm={24}
                              md={14}
                              lg={14}
                              style={{ paddingRight: "25px" }}
                            >
                              <div className="d-flex">
                                <Form.Item
                                  className="custom-work"
                                  {...restField}
                                  label="Event Name"
                                  labelCol={{ span: 8 }}
                                  name={[name, "eventName"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Event Name is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter Event Name"
                                    maxLength={100}
                                    showCount={{ formatter: ({ count }) => `${count}/100` }}
                                  />
                                </Form.Item>

                                <Form.Item>
                                  <div className="remove-btn">
                                    <DeleteOutlined
                                      title="Delete"
                                      onClick={() => {
                                        const id = form.getFieldValue([whichTab, i, "id"]);
                                        if (id) {
                                          deleteSingleItem(whichTab, id, form);
                                        } else {
                                          remove(name);
                                          setHasUnsavedItem(false);
                                          refreshUnsavedState();
                                        }
                                      }}
                                    />
                                  </div>
                                </Form.Item>
                              </div>

                              <Form.Item
                                {...restField}
                                label="Event Logo"
                                colon={false}
                                name={[name, "eventLogo"]}
                                className="experienceImg"
                                labelCol={{ span: 8 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Event Logo is required",
                                  },
                                  {
                                    validator: () => {
                                      if (hasEventLogo(name)) {
                                        return Promise.resolve();
                                      }
                                      return Promise.reject(new Error("Event Logo is required"));
                                    },
                                  },
                                ]}
                              >
                                {findValue(i, "logoBlob") ? (
                                  <Avatar src={URL.createObjectURL(findValue(i, "logoBlob"))} alt="" />
                                ) : findValue(i, "eventLogo")?.url ? (
                                  <Avatar src={findValue(i, "eventLogo").url} alt="" />
                                ) : (
                                  <Avatar src={UserIcon} />
                                )}
                                <label name="file" className="fileUploadBtn greenBtn">
                                  Upload Logo
                                  <input
                                    accept="image/png, image/gif, image/jpeg"
                                    type="file"
                                    onChange={(e) => updateEventLogo(e, i)}
                                  />
                                </label>
                                <Tooltip
                                  className="question"
                                  title="Recommended logo size: 400x400 pixels, max 2.5MB"
                                >
                                  <QuestionCircleOutlined />
                                </Tooltip>
                              </Form.Item>

                              <Form.Item
                                label="Event Overview"
                                {...restField}
                                labelCol={{ span: 8 }}
                                name={[name, "description"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Event Overview is required",
                                  },
                                  {
                                    max: EVENT_OVERVIEW_MAX,
                                    message: `Event Overview should not exceed ${EVENT_OVERVIEW_MAX} characters`,
                                  },
                                ]}
                              >
                                <TextArea
                                  style={{ marginBottom: "10px" }}
                                  placeholder="Enter Event Overview"
                                  rows={4}
                                  maxLength={EVENT_OVERVIEW_MAX}
                                  showCount
                                />
                              </Form.Item>

                              <Form.Item
                                label="More Information"
                                {...restField}
                                labelCol={{ span: 8 }}
                                name={[name, "moreInfo"]}
                              >
                                <TextArea rows={5} placeholder="Enter More Information" />
                              </Form.Item>

                              <div className="d-flex">
                                <Form.Item
                                  {...restField}
                                  name={[name, "mediaLink", "mediaType"]}
                                  className="w-100"
                                  label="Video or Image"
                                  labelCol={{ span: 8 }}
                                >
                                  <Select
                                    placeholder="Select Option"
                                    allowClear
                                    onChange={(e) => SelectChangeHandler(e, i)}
                                  >
                                    <Select.Option value="VIMEO_MEDIA">Add Vimeo Link</Select.Option>
                                    <Select.Option value="SOCIAL_MEDIA">Add Youtube Link</Select.Option>
                                    <Select.Option value="SYNTHESIA_MEDIA">Add Synthesia Link</Select.Option>
                                    <Select.Option value="IMAGE">Upload Image</Select.Option>
                                    <Select.Option value="GIF">Create GIF</Select.Option>
                                  </Select>
                                </Form.Item>
                                <Form.Item>
                                  <div className="remove-btn">
                                    <Tooltip
                                      title="Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio"
                                    >
                                      <QuestionCircleOutlined />
                                    </Tooltip>
                                  </div>
                                </Form.Item>
                              </div>

                              {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                <Form.Item
                                  label="Youtube Link"
                                  labelCol={{ span: 8 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input />
                                </Form.Item>
                              ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                <Form.Item
                                  label="Vimeo Link"
                                  labelCol={{ span: 8 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input />
                                </Form.Item>
                              ) : findValue(i, "type") === "IMAGE" ? (
                                <Form.Item
                                  {...restField}
                                  label="Image"
                                  colon={false}
                                  name="media"
                                  className="experienceImg"
                                  labelCol={{ span: 8 }}
                                >
                                  {findValue(i, "blob") ? (
                                    <Avatar src={URL.createObjectURL(findValue(i, "blob"))} alt="" />
                                  ) : findValue(i, "url") ? (
                                    <Avatar src={findValue(i, "url")} alt="" />
                                  ) : (
                                    <Avatar src={UserIcon} />
                                  )}
                                  <label name="file" className="fileUploadBtn greenBtn">
                                    Upload Image
                                    <input
                                      accept="image/png, image/gif, image/jpeg"
                                      type="file"
                                      onChange={(e) => {
                                        updateImage(e, i, form, whichTab);
                                        setTimeout(() => setRefreshKey((prev) => prev + 1), 200);
                                      }}
                                    />
                                  </label>
                                  <Tooltip
                                    className="question"
                                    title="Recommended image dimensions: 1280x720 pixels"
                                  >
                                    <QuestionCircleOutlined />
                                  </Tooltip>
                                </Form.Item>
                              ) : findValue(i, "type") === "GIF" ? (
                                <Form.Item
                                  {...restField}
                                  label="Create GIF"
                                  colon={false}
                                  name={[name, "mediaLink", "gifCreator"]}
                                  className="gif-creator-field"
                                  labelCol={{ span: 8 }}
                                  initialValue={createEmptyGifState()}
                                >
                                  <GifCreator />
                                </Form.Item>
                              ) : findValue(i, "type") === "SYNTHESIA_MEDIA" ? (
                                <Form.Item
                                  label="Synthesia Link"
                                  labelCol={{ span: 8 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input />
                                </Form.Item>
                              ) : null}

                              <Row className="date-picker-row" gutter={{ xs: 8, sm: 16, md: 24 }}>
                                <Col xs={34} sm={24} md={24} lg={24}>
                                  <Form.Item
                                    label="Start Date"
                                    {...restField}
                                    labelCol={{ span: 8 }}
                                    name={[name, "startDate"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "Start Date is required",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      className="w-100"
                                      format="DD/MM/YYYY"
                                      placeholder="Select Event Start Date"
                                      disabledDate={(current) => {
                                        if (!current) return false;
                                        const today = moment().startOf("day");
                                        return current < today;
                                      }}
                                      onChange={(date) => {
                                        const endDate = form.getFieldValue([whichTab, i, "endDate"]);
                                        if (date && endDate && endDate._isAMomentObject) {
                                          if (endDate.startOf("day").isBefore(date.startOf("day"))) {
                                            form.setFieldValue([whichTab, i, "endDate"], null);
                                          }
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={34} sm={24} md={24} lg={24}>
                                  <Form.Item
                                    label="End Date"
                                    {...restField}
                                    labelCol={{ span: 8 }}
                                    name={[name, "endDate"]}
                                    rules={[
                                      {
                                        required: true,
                                        message: "End Date is required",
                                      },
                                    ]}
                                  >
                                    <DatePicker
                                      className="w-100"
                                      format="DD/MM/YYYY"
                                      placeholder="Select End Date"
                                      disabledDate={(current) => {
                                        if (!current) return false;
                                        const startDate = form.getFieldValue([whichTab, i, "startDate"]);
                                        const today = moment().startOf("day");
                                        if (startDate && startDate._isAMomentObject) {
                                          return current < startDate.startOf("day");
                                        }
                                        return current < today;
                                      }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Form.Item
                                {...restField}
                                label="Country"
                                labelCol={{ span: 8 }}
                                name={[name, "country"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Country is required",
                                  },
                                ]}
                              >
                                <div className="country-select-wrapper">
                                  <ReactFlagsSelect
                                    searchable
                                    searchPlaceholder="Search country"
                                    placeholder="Select Country"
                                    selected={form.getFieldValue([whichTab, name, "country"]) || ""}
                                    onSelect={(code) => {
                                      form.setFieldValue([whichTab, name, "country"], code);
                                      form.validateFields([[whichTab, name, "country"]]).catch(() => { });
                                      const prev = updatedValues;
                                      const prevItems = prev[whichTab];
                                      if (prevItems) {
                                        const names = [...prevItems, name];
                                        prev[whichTab] = names.filter(
                                          (item, idx, arr) => arr.indexOf(item) === idx
                                        );
                                      } else {
                                        prev[whichTab] = [name];
                                      }
                                      dispatch(setUpdatedValues(prev));
                                    }}
                                    className="country-select"
                                  />
                                </div>
                              </Form.Item>
                              <Form.Item
                                label="Find Out More"
                                {...restField}
                                labelCol={{ span: 8 }}
                                name={[name, "webLink"]}
                                rules={[{ type: "url", message: "Please enter a valid URL" }]}
                              >
                                <Input placeholder="https://example.com" />
                              </Form.Item>

                              <Form.Item
                                label="Venue Address"
                                {...restField}
                                labelCol={{ span: 8 }}
                                name={[name, "address"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Venue Address is required",
                                  },
                                ]}
                              >
                                <TextArea placeholder="Enter Venue Address" rows={3} />
                              </Form.Item>

                              <Form.Item
                                label="Venue Website"
                                {...restField}
                                labelCol={{ span: 8 }}
                                name={[name, "venueLink"]}
                                rules={[{ type: "url", message: "Please enter a valid URL" }]}
                              >
                                <Input placeholder="https://example.com" />
                              </Form.Item>

                              <Form.Item
                                className="w-100"
                                style={{ display: "flex", justifyContent: "end" }}
                              >
                                {formChanged ? (
                                  <Button
                                    className="saveBtn greenBtn"
                                    onClick={() => handleSaveEvent(name)}
                                  >
                                    Save
                                  </Button>
                                ) : (
                                  <Button
                                    className="saveBtn greenBtn"
                                    style={{ opacity: "0.5", pointerEvents: "none" }}
                                  >
                                    Save
                                  </Button>
                                )}
                              </Form.Item>
                            </Col>

                            <Col className="gutter-row tabContent" xs={24} sm={24} md={10} lg={10}>
                              {form.getFieldValue(whichTab)?.[i] ? (
                                <div key={refreshKey}>
                                  {renderMedia(form.getFieldValue(whichTab)[i], i)}
                                </div>
                              ) : null}
                            </Col>
                          </div>
                        )}
                      />
                    </>
                  );
                }}
              </Form.List>
            </Col>
          </>
        ) : (
          <></>
        )}
      </Row>
    </div>
  );
}